export default ({
  street_1 = null,
  street_2 = null,
  city = null,
  company = null,
  country = null,
  customer_name = null,
  zip = null,
  state = null,
}) => ({
  address_line1: street_1,
  address_line2: street_2,
  city,
  company_name: company,
  country,
  country_code: country,
  first_name: customer_name,
  postal_code: zip,
  province: state,
});
